<template>
  <div v-if="false">
    <div
      class="modal"
      id="googleFormsModal"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-g-forms" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <form action="/online/feedback/send" method="POST">
              <input name="_token" type="hidden" :value="csrf">
              <div id="feedback-step1" v-show="!step">
                <h4 class="mb-5 mt-3 text-center">Como tem saído a impressão de seus cartazes nos últimos dias?</h4>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <div class="row mt-3 d-flex justify-content-center">
                        <label class="form-check-label" for="isCorrectImpressionYes">
                          <img :src="correctPrintImage" alt="img" width="300">
                        </label>
                      </div>
                      <div class="row mt-3 d-flex justify-content-center">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="is_correct_impression"
                          id="isCorrectImpressionYes"
                          v-model="isCorrectImpressionNo"
                          value="1">
                        <label class="form-check-label" for="isCorrectImpressionYes">Corretas</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <div class="row mt-3 d-flex justify-content-center">
                        <label class="form-check-label" for="isCorrectImpressionNo">
                          <img :src="wrongPrintImage" alt="img" width="300">
                        </label>
                      </div>

                      <div class="row mt-3 d-flex justify-content-center">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="is_correct_impression"
                          id="isCorrectImpressionNo"
                          v-model="isCorrectImpressionNo"
                          value="0">
                        <label class="form-check-label" for="isCorrectImpressionNo">
                          Incorretas
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-5 d-flex justify-content-center">
                    <button
                      :disabled="!isCorrectImpressionNo"
                      type="button"
                      class="btn btn-outline-secondary btn-block col-3 float-right"
                      @click="step = !step">
                      Próxima
                      <i class="fa fa-long-arrow-alt-right mr-2"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div id="feedback-step2" v-show="step">
                <h4 class="mb-5 mt-3 text-center">Você está imprimindo seus cartazes clicando em qual botão?</h4>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <div class="row mt-3 d-flex justify-content-center">
                        <label class="form-check-label" for="isPrintPdfYes">
                          <img :src="printPdfButtonImage" alt="img" width="300">
                        </label>
                      </div>
                      <div class="row mt-3 d-flex justify-content-center">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="is_print_pdf_button"
                          id="isPrintPdfYes"
                          v-model="isPrintPdfButton"
                          value="1">
                        <label class="form-check-label" for="isPrintPdfYes">
                          Imprimir PDF
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <div class="row mt-3 d-flex justify-content-center">
                        <label class="form-check-label" for="isPrintPdfNo">
                          <img :src="printButtonImage" alt="img" width="300">
                        </label>
                      </div>

                      <div class="row mt-3 d-flex justify-content-center">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="is_print_pdf_button"
                          id="isPrintPdfNo"
                          v-model="isPrintPdfButton"
                          value="0">
                        <label class="form-check-label" for="isPrintPdfNo">
                          Imprimir
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <input name="browser" type="hidden" :value="browser">
                <input name="operacional_system" type="hidden" :value="operacionalSystem">

                <div class="row mt-5 d-flex justify-content-center">
                  <button
                    type="submit"
                    class="btn btn-outline-secondary btn-block col-3 float-right"
                    :disabled="!isPrintPdfButton">
                    <i class="fa fa-check mr-2"></i> Enviar
                  </button>
                </div>
              </div>
            </form>
          </div>
          <img src="/img/rodape-magazine.svg" alt="footer" class="magazine-footer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrintFeedbackForm",

  props: {
    correctPrintImage: {
      type: String,
      required: false,
    },
    wrongPrintImage: {
      type: String,
      required: false,
    },
    printPdfButtonImage: {
      type: String,
      required: false,
    },
    printButtonImage: {
      type: String,
      required: false,
    },
    canSendFeedback: Boolean,
  },

  data() {
    return {
      browser: undefined,
      operacionalSystem: undefined,
      isCorrectImpressionNo: null,
      isPrintPdfButton: null,

      step: false
    }
  },

  mounted() {
    this.$root.$on('print-feedback-form', () => {
      $('#googleFormsModal').appendTo("body").modal('show');
    })
    this.getBrowser();
    this.getOperacionalSystem();
  },

  computed: {
    csrf() {
      return $('meta[name="csrf-token"]').attr('content');
    },
  },

  methods: {

    getBrowser() {
      this.browser = navigator.sayswho = (function () {
        var ua = navigator.userAgent, tem,
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
          if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
      })();

      return this.browser;
    },

    getOperacionalSystem() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'];

      if (macosPlatforms.indexOf(platform) !== -1) {
        this.operacionalSystem = 'Mac OS';
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        this.operacionalSystem = 'iOS';
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        this.operacionalSystem = 'Windows';
      } else if (/Android/.test(userAgent)) {
        this.operacionalSystem = 'Android';
      } else if (!this.operacionalSystem && /Linux/.test(platform)) {
        this.operacionalSystem = 'Linux';
      }

      return this.operacionalSystem;
    },

  }
}
</script>

<style scoped>
.modal-backdrop {
  z-index: -1 !important;
}

label {
  font-weight: 600;
}

.modal-g-forms {
  max-width: 56% !important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PrintFeedbackForm.vue